import { ArticleDTO, ArticleModel } from "@/entities/Article";
import { MediaDTO, MediaModel } from "@/entities/Media";

import { ref } from "vue";
import useAPIRequest from "@/composables/useAPIRequest";

const homeContentQuery = `{
  "medias":
    *[
      _type == 'media'
      && !(_id in path('drafts.**'))
      && isFeatured == true
      && type != "cine"
    ]
    [0...8]
    | order(premierDate desc)
    {
      _id,
      title,
      "slug": slug.current,
      type,
      isFeatured,
      premierDate,
      "poster": poster.asset->url,
      mediaId
    },
  "cineMedias":
    *[
      _type == 'media'
      && !(_id in path('drafts.**'))
      && isFeatured == true
      && type == "cine"
    ]
    [0...8]
    | order(premierDate desc)
    {
      _id,
      title,
      "slug": slug.current,
      type,
      isFeatured,
      premierDate,
      "poster": poster.asset->url,
      mediaId
    },
  "articles":
    *[
      _type == 'article'
      && !(_id in path("drafts.**"))
      && date <= now()
    ]
    | order(date desc)
    {
      _id,
      title,
      date,
      "slug": slug.current,
      "image": image.asset->url
    }
}`;

export default function useHome() {
  const medias = ref<MediaModel[]>([]);
  const cineMedias = ref<MediaModel[]>([]);
  const articles = ref<ArticleModel[]>([]);
  const { fetch, requestState } = useAPIRequest<{
    medias: MediaDTO[];
    cineMedias: MediaDTO[];
    articles: ArticleDTO[];
  }>();
  const fetchHomeContent = async () => {
    await fetch(homeContentQuery);
    if (requestState.value.status === "ready" && requestState.value.data) {
      medias.value =
        requestState.value.data?.medias.map(
          (m: MediaDTO) => new MediaModel(m)
        ) || [];
      cineMedias.value =
        requestState.value.data?.cineMedias.map(
          (m: MediaDTO) => new MediaModel(m)
        ) || [];
      articles.value =
        requestState.value.data?.articles.map(
          (m: ArticleDTO) => new ArticleModel(m)
        ) || [];
    }
  };

  return {
    fetch: fetchHomeContent,
    medias,
    cineMedias,
    articles,
    requestState,
  };
}
